var chunkMapping = {
	"0": [
		4636
	],
	"3": [
		4059,
		4345
	],
	"77": [
		5065
	],
	"159": [
		5147
	],
	"160": [
		5148
	],
	"163": [
		5151
	],
	"164": [
		5152
	],
	"165": [
		5153
	],
	"166": [
		5154
	],
	"167": [
		5155
	],
	"168": [
		5156
	],
	"169": [
		5157
	],
	"170": [
		5158
	],
	"171": [
		5159
	],
	"172": [
		5160
	],
	"173": [
		5161
	],
	"174": [
		5162
	],
	"175": [
		5163
	],
	"176": [
		5164
	],
	"177": [
		5165
	],
	"178": [
		5166
	],
	"179": [
		5167
	],
	"180": [
		5168
	],
	"181": [
		5169
	]
};
var idToExternalAndNameMapping = {
	"4059": [
		"default",
		"./nuorder-components",
		3672
	],
	"4345": [
		"default",
		"./helios-components",
		3672
	],
	"4636": [
		"default",
		"./Containers",
		3582
	],
	"5065": [
		"default",
		"./OrderlessInvoices",
		3582
	],
	"5147": [
		"default",
		"./AsyncEventTracker",
		3582
	],
	"5148": [
		"default",
		"./HostWrapper",
		3582
	],
	"5151": [
		"default",
		"./CheckoutV3",
		3582
	],
	"5152": [
		"default",
		"./CheckoutConfirmation",
		3582
	],
	"5153": [
		"default",
		"./ContactCreditCards",
		3582
	],
	"5154": [
		"default",
		"./AuditDialog",
		3582
	],
	"5155": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3582
	],
	"5156": [
		"default",
		"./InvoiceDialog",
		3582
	],
	"5157": [
		"default",
		"./PaymentDueModal",
		3582
	],
	"5158": [
		"default",
		"./PaymentModal",
		3582
	],
	"5159": [
		"default",
		"./PaymentHistory",
		3582
	],
	"5160": [
		"default",
		"./PaymentConfigurations",
		3582
	],
	"5161": [
		"default",
		"./PaymentPreferences",
		3582
	],
	"5162": [
		"default",
		"./ManagePaymentProcessing",
		3582
	],
	"5163": [
		"default",
		"./MobilePaymentsWrapper",
		3582
	],
	"5164": [
		"default",
		"./Challenge",
		3582
	],
	"5165": [
		"default",
		"./ManagePaymentMethods",
		3582
	],
	"5166": [
		"default",
		"./LightspeedReports",
		3582
	],
	"5167": [
		"default",
		"./ActivateLightspeedPayments",
		3582
	],
	"5168": [
		"default",
		"./MarketingLandingPage",
		3582
	],
	"5169": [
		"default",
		"./ShippingPromotionsListContainer",
		3582
	]
};
var idToRemoteMap = {
	"4059": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4345": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3672
		}
	],
	"4636": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5065": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5152": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5153": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5154": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5155": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5156": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5157": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5158": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5159": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5160": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5161": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5162": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5163": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5164": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5165": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5166": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5167": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5168": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	],
	"5169": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3582
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}